import React, { useReducer, useEffect, useContext, useRef} from "react";
import nivel2Context from "./nivel2Context";
import { getAllNivel2s, addNivel2, updateNivel2, deleteNivel2, deleteNivel2AndChildren } from "../../api/nivel2";
import nivel2Reducer from "./nivel2Reducer";
import authContext from "../authentication/authContex";


//Types
import { 
    ACTUALIZAR_LIST_NIVEL2,
  } from "./nivel2Actions";
import { SocketContext } from "../socket/socket";
import { updatePositioning } from "../../api/nivel2";
import Swal from "sweetalert2";


const Nivel2State = props =>{
    
    const initialState = {
        nivel2List: null
     };
    
    const [state, dispatch] = useReducer(nivel2Reducer, initialState);
    
    const auContext = useContext(authContext);
    const {verificarTenant, usuario} = auContext;
    const server = useContext(SocketContext);

    const nivel2ListRef = useRef(state.nivel2List);

    const actualizarNivel2List = async () => {
        try{
            const resp = await getAllNivel2s();
            let nivel2 = resp.data.data;
            nivel2 = nivel2.map((lv2,i) => ({...lv2, position: lv2.position ?? i + 1})); 
            nivel2ListRef.current = nivel2;
            dispatch({
                type: ACTUALIZAR_LIST_NIVEL2,
                payload: nivel2
            });
            
            return nivel2;
        }catch(err){
            console.log(err)
        }

    };

    const agregarNivel2 = async (datos) => {
        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addnivel2
            const resp = await addNivel2(datos);
            const nivel2 = resp.data.data;
            return {saved:true, lv2Saved: nivel2};
        }catch(err){
            let msg = err.response?.data?.message ?? 'Error desconocido'
            let customMsg = msg.includes("duplicate key error") ? 'Código o Nombre se está repitiendo.' : msg;
            return {saved: false, msg: customMsg};  
        }   
    };

    const modificarNivel2 = async (dato) => {
        try{
            
            const resp = await updateNivel2(dato);
            const activo = resp.data.data;
            
            return activo;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarNivel2 = async (id) => {
        try{
            
            const resp = await deleteNivel2(id);
            const activo = resp.data.data;
            
            return activo;
        }catch(err){
            console.log(err)
        }
    }

    const eliminarNivel2eHijos = async(id, deleteActivesToo = false, from = '') => {
        try {

            const resp = await deleteNivel2AndChildren(id, deleteActivesToo);
            const nivel2 = resp.data.data;
            const swalConfig = {title:'Eliminado!', html: nivel2, icon:'success'};
            if(from === 'TreeActivo') return swalConfig;
            Swal.fire(swalConfig);
            return nivel2;
        } catch (error) {
            console.log(error)
            const errorConfig = {title:'Ops!', text: error?.response?.data?.data ?? 'Error al eliminar', icon:'error'};
            if(from === 'TreeActivo') return errorConfig;
            if(error.response?.status == 401) Swal.fire(errorConfig);
        }
    }

    const updatePositionLv2 = async (updates) => {
        let lvs2Updated = nivel2ListRef.current ?? [];
        lvs2Updated = lvs2Updated.map(a => {
            let lvFound = updates.find(upd => upd._id == a._id);
            return {
                ...a,
                position: lvFound ? lvFound.position : a.position
            }
        });
        nivel2ListRef.current = lvs2Updated;
        await updatePositioning(updates);
        dispatch({
            type: ACTUALIZAR_LIST_NIVEL2,
            payload: lvs2Updated
        });
    }
    

    useEffect(() => {
        if(usuario != null) actualizarNivel2List();
    },[usuario])

    useEffect(()=>{
        if(server){
            server.on('nivel2sUpdated', ({tenantId}) => {
                console.log("Recibo el evento del Real Time Server nivel2sUpdated");
                let update = verificarTenant(tenantId);
                if(update){
                    actualizarNivel2List();
                }
            });

            server.on('nivel2Eliminated', ({tenantId}) => {
                let update = verificarTenant(tenantId);
                if(update){
                    actualizarNivel2List();
                }
            })

            return () => {
                server.off('nivel2sUpdated');
                server.off('nivel2Eliminated');
            }
        }
    },[server])

    return(
        <nivel2Context.Provider
            value={{
                nivel2List: state.nivel2List,
                actualizarNivel2List,
                agregarNivel2,
                modificarNivel2,
                eliminarNivel2,
                eliminarNivel2eHijos,
                updatePositionLv2
            }}
        >
            {props.children}
        </nivel2Context.Provider>
    )

}

export default Nivel2State;